import axios from "axios";
import { config } from "../config";
import { Region } from "../types";

export const api = (region: Region, token?: string) => {
  const baseURL = config.apiBaseUrls.find(
    (u) => u.region.toLowerCase().trim() === region.toLowerCase().trim(),
  )?.url;

  if (baseURL == null) {
    throw new Error(`No url found for region: ${region}`);
  }

  return axios.create({
    baseURL,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 15000,
  });
};

export const displayStatusApi = () => {
  return axios.create({
    baseURL: config.displayStatus.url,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    timeout: 15000,
  });
};
